import React, { useEffect, useState } from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import api from '../../utils/api';
import { useTenant } from '../../context/TenantContext';

const ClientTasks = () => {
  const { activeTenant } = useTenant();
  const [tasks, setTasks] = useState([]);
  const statusLabels = {
    'En proceso': 'En proceso',
    'Pendiente cliente': 'Pendiente cliente',
    Validando: 'Validando',
    Exportado: 'Exportado',
    Cerrado: 'Cerrado',
    New: 'En proceso',
    InProgress: 'Validando',
    InReview: 'Exportado',
    BlockedClient: 'Pendiente cliente',
    Delivered: 'Cerrado',
  };
  const priorityLabels = {
    low: 'Baja',
    medium: 'Media',
    high: 'Alta',
  };

  useEffect(() => {
    if (activeTenant) {
      api.get(`/tasks?tenant_id=${activeTenant}`).then((res) => setTasks(res.data));
    }
  }, [activeTenant]);

  return (
    <div data-testid="client-tasks-page" className="max-w-5xl mx-auto">
      <h1 className="text-4xl font-heading font-bold mb-6">Mis Tareas</h1>
      <div className="space-y-4">
        {tasks.map((task) => (
          <Card
            key={task.id}
            className="hover:border-primary/50 hover:shadow-md transition-all"
            data-testid={`task-${task.id}`}
          >
            <CardContent className="p-6">
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <h3 className="text-lg font-medium mb-2">{task.title}</h3>
                  <p className="text-muted-foreground text-sm mb-4">{task.description}</p>
                  <div className="flex items-center gap-4 text-sm">
                    <Badge>{statusLabels[task.status] || task.status}</Badge>
                    <Badge variant={task.priority === 'high' ? 'destructive' : 'secondary'}>
                      {priorityLabels[task.priority] || task.priority}
                    </Badge>
                    <span className="text-muted-foreground">
                      Vence: {new Date(task.due_date).toLocaleDateString()}
                    </span>
                  </div>
                  {task.blocked_reason && (
                    <div className="mt-3 p-3 bg-secondary/10 border border-secondary/20 rounded-lg">
                      <span className="text-sm text-secondary font-medium">
                        Aviso: Bloqueado: {task.blocked_reason}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};
export default ClientTasks;
